import { Action, mkWidget, route, Widget, async, AsyncState, onlyIf, loadingAsyncState } from "widgets-for-react";
import { CustomPage, CustomPagesState, PublicSiteCustomRoutes, Vacancy } from "../../types.mod";
import { PublicSiteState } from "../../../../../public_site.main.mod";
import { CustomRouteParams } from "../../../../cms/router/type.gen";
import { getFormState } from "../../../../form/api";
import React = require("react");
import { getLangFromUrl } from "../../../utils/history.mod";
import { getDrupalLanguage } from '../../../application.mod';
import { vacancyApplicationFormPageHeader } from "../../../templates/custom_page_header";
import { t } from 'i18next'
import { getVacancy } from "./vacancy_detail";
import { SuccessForm } from "../../../../form";
import { FormState } from "../../../../form/types";
import { vacancyFormFormDatalayer } from "../../../../datalayer";

export const vacancyDetailSuccessPathPattern = `/:lang?/:careers/vacancies/id/:vacancyId/:title/:tag/success`

export const vacancy_detail_success: CustomPage<CustomPagesState["success"]> = {
  widget: _r => mkWidget({
    run: (setState: (_: Action<CustomPagesState["success"]>) => void) => {
      let r = { ..._r }
      let s = r.snd;
      
      return vacancyDetailSuccessWidget(s).run(setState)
    }
  }),
  route: route<
    {
      vacancyId: string
    },
    CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>
  >(vacancyDetailSuccessPathPattern, (s) => {
    return {
      kind: 'success',
      vacancyId: s.vacancyId
    }
  }),
  getState: (s: PublicSiteState) => s.success,
  setState: (s: PublicSiteState, ss: CustomPagesState["success"]) => ({ ...s, success: ss }),
  updateStateBasesOnRoute: (s, r) => {
    if (r.kind != "success") return s

    return ({
      ...s,
      success: {
        ...s.success,
        get_vacancy: loadingAsyncState(() => getVacancy(r.vacancyId)),
        form: {
          ...getFormState([], `VacancyApplication2`, r.vacancyId),
          custom_context: { VacancyId: r.vacancyId, Kind: "", Language: getDrupalLanguage(getLangFromUrl()) }
        }
      }
    })
  }
}

const vacancyDetailSuccessWidget = (s: CustomPagesState["success"]): Widget<Action<CustomPagesState["success"]>> => {
  let vacancy = s.get_vacancy && s.get_vacancy.kind == "loaded" ? s.get_vacancy.value : undefined

  return mkWidget({
    run: set_state => {
      return <>
        <div className='main main--vacancy'>
          <div className='main__inner'>
            <div className='page'>
              <div className='page__inner'>
                {async<Vacancy>()(s.get_vacancy).map(a =>
                  s => {
                    let s1 = { ...s, get_vacancy: a(s.get_vacancy) }
                    let form = s1.form
                    let vacancy: AsyncState<Vacancy> = s1.get_vacancy
                    if (vacancy.kind == "loaded") {
                      form.custom_context.Kind = vacancy.value.Kind
                    }
                    return s1
                  }).run(a => {
                    set_state(a)
                  })}

                <div className='page__content'>
                  {onlyIf(s.get_vacancy.kind == "loaded",
                    mkWidget({
                      run: set_state => {
                        return (
                          <>
                            {vacancyApplicationFormPageHeader(vacancy.Name).run(_ => ({ _ }))}
                            <section className="block block--form">
                              <div className="block__inner container container--m grid--block">
                                <div className="block__content">
                                  {<>
                                    <a className="link link--back" onClick={_ => window.location.href = window.location.href.replace('/success/', '')}>
                                      <span>{t("Vacancy:return_to_vacancy")}</span>
                                      <svg className="link__icon" height="14" width="18">
                                        <use xlinkHref="#icon--arrow" />
                                      </svg>
                                    </a>
                                    <h2 className="block__title">{t("Vacancy:application_for")} {vacancy.Name}</h2>
                                  </>}

                                  {
                                    SuccessForm(s.form)
                                      .map((a) => (s) => {
                                        let form1: FormState = a(s.form)
                                        if (form1.form_submission_logic.kind == "loaded") {
                                          vacancyFormFormDatalayer("submit_application")
                                        }
                                        let s1 = { ...s, form: form1 }
                                        return s1
                                      })
                                      .run(set_state)
                                  }

                                </div>
                              </div>
                            </section>
                          </>
                        )
                      }
                    })).run(set_state)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    }
  })
}
